import React, { useEffect, useState } from "react";
import { Table, Modal, Badge, Card } from "react-bootstrap";
import axios from "axios";
import logo from "../images/TP-_logo-orizz-claim-color.png";
import {
  FaMapMarkerAlt,
  FaCubes,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

function BasicExample() {
  const [sortedClientiData, setSortedClientiData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "valore",
    direction: "descending",
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("mancata_vendita_dashboard.json");
        if (!res.data?.AR?.localita) return;
        const clientiData = res.data.AR.localita || [];
        const lastMinuti = res.data.AR.lastminuti || [];
        const today = new Date().toISOString().split("T")[0];

        const expressMap = lastMinuti.reduce((acc, lm) => {
          if (!lm.ordinato) return acc;
          const dataOrdine = lm.data_ordine?.split(" ")[0];
          if (dataOrdine !== today) return acc;
          const key = `${lm.codice_cliente}-${lm.origine || "noweb"}`;
          const valore = parseFloat(lm.ordinato.replace(",", ".")) || 0;
          acc[key] = (acc[key] || 0) + valore;
          return acc;
        }, {});

        const transformedData = clientiData.reduce((acc, item) => {
          const id = item.id_cliente;
          const origine = item.origine || "noweb";
          const key = `${id}-${origine}`;
          const valore = parseFloat(item.Valore?.replace(",", ".")) || 0;

          if (!acc[key]) {
            acc[key] = {
              id_cliente: id,
              cliente: item.clienti,
              valore: 0,
              express: 0,
              regular: 0,
              numero: 0,
              localita: item.regione || item.nazione || item.paese,
              origine,
              dettagli: {}, // CORREZIONE: Inizializzato come oggetto per raggruppare per chiave
            };
          }
          acc[key].valore += valore;
          acc[key].numero += Number(item.numero_doc || 0);

          // Raggruppamento e somma per Marchio (descrizione)
          const marchio = item.descrizione || "Generico";
          acc[key].dettagli[marchio] = (acc[key].dettagli[marchio] || 0) + valore;

          return acc;
        }, {});

        Object.values(transformedData).forEach((cliente) => {
          const key = `${cliente.id_cliente}-${cliente.origine}`;
          const express = expressMap[key] || 0;
          cliente.express = Math.min(express, cliente.valore);
          cliente.regular = cliente.valore - cliente.express;

          // CORREZIONE: Riconvertiamo l'oggetto temporaneo in array per il .map del JSX
          // In più ordiniamo i marchi in ordine decrescente di valore complessivo
          cliente.dettagli = Object.entries(cliente.dettagli)
            .map(([marchio, totaleMarchio]) => ({
              descrizione: marchio,
              valore: totaleMarchio,
            }))
            .sort((a, b) => b.valore - a.valore);
        });

        setSortedClientiData(
          sortArray(
            Object.values(transformedData),
            sortConfig.key,
            sortConfig.direction,
          ),
        );
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [sortConfig]);

  const sortArray = (array, key, direction) => {
    return [...array].sort((a, b) => {
      const aValue = a[key] ?? 0;
      const bValue = b[key] ?? 0;
      if (typeof aValue === "number")
        return direction === "ascending" ? aValue - bValue : bValue - aValue;
      return direction === "ascending"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction:
        sortConfig.key === key && sortConfig.direction === "ascending"
          ? "descending"
          : "ascending",
    });
  };

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  return (
    <>
      <Card
        className="card bg-dark ombra ordini-ora card-home hover-effect border-0"
        style={{ borderRadius: "15px", padding: "1.2rem", paddingBottom: "0" }}
      >
        <div
          className="no-scrollbar"
          style={{
            width: "100%",
            height: 300,
            overflowY: "auto",
            overflowX: "auto",
            position: "relative",
            scrollbarWidth: "thin",
          }}
        >
          <Table
            hover
            className="mb-0 custom-table"
            style={{
              fontSize: "0.75rem",
              width: "100%",
              margin: 0,
              borderCollapse: "separate",
            }}
          >
            <thead className="sticky-top bg-white" style={{ zIndex: 10 }}>
              <tr
                className="text-light small bg-dark"
                style={{ borderBottom: "2px solid #f1f1f1" }}
              >
                <th style={{ width: "25%" }} className="ps-4 py-3 border-0 bg-dark text-light">
                  CLIENTE
                </th>
                <th
                  style={{ width: "15%" }}
                  className="py-3 border-0 cursor-pointer bg-dark text-light"
                  onClick={() => handleSort("localita")}
                >
                  LOCALITÀ
                </th>
                <th
                  className="py-3 bg-dark fw-bold border-0 text-end"
                  style={{ color: "rgba(241,111,36,1)", width: "30%" }}
                >
                  VALORE
                </th>
                <th style={{ width: "8%" }} className="py-3 border-0 text-center bg-dark text-light">
                  ORDINI
                </th>
                <th style={{ width: "10%" }} className="py-3 border-0 text-center pe-4 bg-dark text-light">
                  ORIGINE
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedClientiData.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => {
                    setSelectedCliente(item);
                    setShowModal(true);
                  }}
                  className="cursor-pointer align-middle"
                >
                  <td className="ps-4 fw-bold bg-dark text-light truncate-cell">
                    {item.cliente}
                  </td>
                  <td className="bg-dark text-light truncate-cell" style={{ fontSize: "0.7rem" }}>
                    {item.localita}
                  </td>
                  <td className="text-end bg-dark fw-bold" style={{ color: "rgba(241,111,36,1)" }}>
                    {formatToEuro(item.valore)}
                  </td>
                  <td className="text-center bg-dark text-light">
                    <span className="bg-dark text-light">{item.numero}</span>
                  </td>
                  <td className="text-center bg-dark text-light pe-4">
                    <Badge
                      pill
                      className={item.origine === "web" ? "bg-primary-subtle text-primary" : "bg-secondary-subtle text-secondary"}
                      style={{ fontSize: "0.6rem" }}
                    >
                      {item.origine.toUpperCase()}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <style>{`
          .custom-table { width: 100% !important; margin: 0 !important; }
          .truncate-cell { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px; }
          .no-wrap { white-space: nowrap; }
          .cursor-pointer { cursor: pointer; }
          .fw-800 { font-weight: 800; }
          tbody tr:hover { background-color: #fbfbfb !important; }
          .sticky-top { top: -1px; background: white !important; box-shadow: 0 2px 2px -1px rgba(0,0,0,0.05); }
          ::-webkit-scrollbar { height: 6px; width: 4px; }
          ::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 10px; }
          .bg-primary-subtle { background-color: #e3f2fd; }
          .bg-secondary-subtle { background-color: #f5f5f5; }
          .ombra { max-width: 100%; }
        `}</style>
      </Card>

      <Modal
        show={showModal}
        className="modale-dettaglio-root"
        dialogClassName="modale-dettaglio-dialog"
        onHide={() => setShowModal(false)}
        centered
        size="sm"
        backdrop={true}
      >
        <Modal.Header closeButton className="border-0 bg-dark text-white pb-3 pt-4 px-4">
          <Modal.Title className="d-flex align-items-center w-100">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center me-3 shadow-sm"
              style={{ 
                width: "45px", 
                height: "45px", 
                backgroundColor: "rgba(241,111,36,0.1)", 
                border: "1px solid rgba(241,111,36,0.3)" 
              }}
            >
              <FaCubes size={22} style={{ color: "rgba(241,111,36,1)" }} />
            </div>
            <div className="overflow-hidden">
              <div style={{ fontSize: "1.25rem", fontWeight: "800", letterSpacing: "-0.5px", lineHeight: "1.2", color: "#fff" }}>
                {selectedCliente?.cliente}
              </div>
              <div className="text-muted fw-medium d-flex align-items-center mt-1" style={{ fontSize: "0.85rem" }}>
                <FaMapMarkerAlt className="me-1 text-danger" /> <span className="text-light ">{selectedCliente?.localita}</span> 
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="bg-dark px-4 pb-4 pt-0">
          <div className="mb-4 d-flex gap-2">
            <Badge bg="secondary" className="bg-opacity-25 text-light fw-normal border border-secondary" style={{ fontSize: "0.7rem", padding: "5px 10px" }}>
              ID: {selectedCliente?.id_cliente}
            </Badge>
            <Badge 
              pill 
              className={selectedCliente?.origine === "web" ? "bg-info bg-opacity-10 text-info border border-info" : "bg-warning bg-opacity-10 text-warning border border-warning"}
              style={{ fontSize: "0.7rem", padding: "5px 10px" }}
            >
              {selectedCliente?.origine?.toUpperCase()}
            </Badge>
          </div>

          <div className="d-flex justify-content-center">
            <div className="rounded-3 border-0 overflow-hidden shadow-sm" style={{ width: "100%", backgroundColor: "#1a1d20" }}>
              <Table hover className="mb-0" style={{ color: "#eee" }}>
                <thead>
                  <tr style={{ backgroundColor: "rgba(255,255,255,0.03)" }}>
                    <th className="ps-3 py-3 bg-dark text-light border-0 text-uppercase" style={{ fontSize: "0.7rem", color: "#888", letterSpacing: "1px" }}>Brand</th>
                    <th className="text-end pe-3 bg-dark text-light py-3 border-0 text-uppercase" style={{ fontSize: "0.7rem", color: "#888", letterSpacing: "1px" }}>Valore</th>
                  </tr>
                </thead>
                <tbody style={{ borderTop: "1px solid #333" }}>
                  {selectedCliente?.dettagli.map((d, i) => (
                    <tr key={i} className="align-middle" style={{ borderBottom: "1px solid #2a2d30" }}>
                      <td className="ps-3 py-3 bg-dark text-light fw-medium border-0" style={{ fontSize: "0.95rem" }}>
                        {d.descrizione}
                      </td>
                      <td className="text-end pe-3 bg-dark text-light py-3 fw-bold border-0" style={{ color: "#fff", fontSize: "1rem" }}>
                        {formatToEuro(d.valore)}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ backgroundColor: "rgba(241,111,36,0.05)" }}>
                    <td className="ps-3 py-3 bg-dark text-light border-0 fw-bold" style={{ fontSize: "0.9rem", color: "#ffffff" }}>TOTALE</td>
                    <td className="text-end pe-3 bg-dark py-3 border-0 fw-800" style={{ fontSize: "1.1rem", color: "rgba(241,111,36,1)" }}>
                      {formatToEuro(selectedCliente?.valore)}
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
          </div>
        </Modal.Body>

        <style>{`
          .modale-dettaglio-root .btn-close {
              filter: invert(1) grayscale(100%) brightness(200%);
              opacity: 0.8;
          }
          .fw-800 { font-weight: 800; }
        `}</style>
      </Modal>    
    </>
  );
}

export default BasicExample;